
export interface PlaceDto {
  id: number;
  name: string;
  vendorName?: string;
}

export interface PlaceInputDto {
  id: number;
  name: string;
}
